module.exports = __webpack_public_path__ + "img/GRGBanking-icon.29e94a19.png";